// box — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: block;
  }

  [part="box"] {
    display: var(--run-box-display, block);
    overflow: var(--run-box-overflow, visible);
    position: var(--run-box-position, static);
    background: var(--run-wf-surface);
    box-shadow: var(--run-wf-shadow, none);
    border-radius: var(--run-box-border-radius, 0);
    padding-block: var(--run-box-padding-y, var(--run-box-padding, 0));
    padding-inline: var(--run-box-padding-x, var(--run-box-padding, 0));
    box-sizing: border-box;
    font-family: var(--run-wf-font-family);
    font-weight: 400;
  }

  [part="box"][data-border] {
    border: 1px dashed var(--run-wf-border);
  }
`;

export function render(host) {
  const {
    surface,
    border,
    borderWidth,
    radius,
    elevation,
    padding,
    paddingX,
    paddingY,
    display,
    overflow,
    position,
    width,
    height,
    minWidth,
    minHeight,
    maxWidth,
    maxHeight,
    as,
    shadowRoot,
  } = host;

  const hasBorder = border !== 'none';

  // Constrain dynamic padding tokens to contracted space-semantic suffixes
  // (RUN-500 §5): unknown/none → 0; 2xl clamps to the largest contracted step.
  const SPACE_SUFFIX = { '2xs': '2xs', xs: 'xs', sm: 'sm', md: 'md', lg: 'lg', xl: 'xl', '2xl': 'xl' };
  const spaceToken = (v) =>
    SPACE_SUFFIX[v] ? `var(--run-space-semantic-${SPACE_SUFFIX[v]})` : '0';

  const paddingInlineToken = spaceToken(paddingX !== null ? paddingX : padding);
  const paddingBlockToken  = spaceToken(paddingY !== null ? paddingY : padding);

  const radiusToken = (() => {
    if (radius === 'none') return '0';
    if (radius === 'full') return `var(--run-radius-semantic-pill)`;
    return '3px';
  })();

  const shadowToken = elevation !== 'none'
    ? `var(--run-wf-shadow)`
    : 'none';

  const widthStyle = width !== null ? `width: ${width};` : '';
  const heightStyle = height !== null ? `height: ${height};` : '';
  const minWidthStyle = minWidth !== null ? `min-width: ${minWidth};` : '';
  const minHeightStyle = minHeight !== null ? `min-height: ${minHeight};` : '';
  const maxWidthStyle = maxWidth !== null ? `max-width: ${maxWidth};` : '';
  const maxHeightStyle = maxHeight !== null ? `max-height: ${maxHeight};` : '';

  const borderAttr = hasBorder ? ' data-border=""' : '';

  shadowRoot.innerHTML = `
    <${as}
      part="box"
      ${borderAttr}
      style="
        --run-box-display: ${display};
        --run-box-overflow: ${overflow};
        --run-box-position: ${position};
        --run-box-border-radius: ${radiusToken};
        --run-box-padding-inline: var(--run-box-padding-x, ${paddingInlineToken});
        --run-box-padding-block: var(--run-box-padding-y, ${paddingBlockToken});
        display: ${display};
        overflow: ${overflow};
        position: ${position};
        background: var(--run-wf-surface);
        box-shadow: ${shadowToken};
        border-radius: ${radiusToken};
        padding-inline: var(--run-box-padding-x, ${paddingInlineToken});
        padding-block: var(--run-box-padding-y, ${paddingBlockToken});
        ${hasBorder ? `border: 1px dashed var(--run-wf-border);` : ''}
        ${widthStyle}
        ${heightStyle}
        ${minWidthStyle}
        ${minHeightStyle}
        ${maxWidthStyle}
        ${maxHeightStyle}
        box-sizing: border-box;
        font-family: var(--run-wf-font-family);
        font-weight: 400;
      "
    ><slot></slot></${as}>
  `;
}